import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {SaleProductModel} from '../entity/saleProduct.model';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SaleProductConverter extends HttpModelConverter<SaleProductModel> {

    protected createInstance(): SaleProductModel {
        return new SaleProductModel();
    }

    protected enrichObject(result: SaleProductModel, src: SaleProductModel) {
    }
}